// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__aP-Ap","vLegacy":"SelectSecondary_vLegacy__2g1VM","error":"SelectSecondary_error__3VqGH","disabled":"SelectSecondary_disabled__2bOa4"};